import React from 'react';
import {Navigate, useRoutes} from 'react-router-dom';
import FirstPage from "./pages/firstPage";
import SecondPage from "./pages/secondPage";
import CertSearch from "./pages/certSearch";


export default function Router() {
    return useRoutes([
        {
            path: '/',
            children: [
                {path: '/', element: <Navigate to="/index" replace/>},
                {path: 'index', element: <FirstPage/>},
                {path: 'about', element: <FirstPage/>},
                {path: 'certification', element: <FirstPage/>},
                {path: 'information', element: <FirstPage/>},
                {path: 'license', element: <FirstPage/>},
                {path: 'customerService', element: <FirstPage/>},
                {path: 'downloadCenter', element: <FirstPage/>},
                {path: 'hireInformation', element: <FirstPage/>},
                {path: 'contact', element: <FirstPage/>},
                {path: 'certificateNotice', element: <FirstPage/>},
                {path: 'certSearch', element: <FirstPage/>},
            ]
        },
    ]);
};
